// Mimic the functionality of a details, but allow for responsive always showing
if (!customElements.get('details-custom')) {
    customElements.define('details-custom', class DetailsCustom extends HTMLElement {
        constructor() {
            super()
            this.details = this.querySelector('.details')
            this.toggle = this.querySelector('summary')

            this.addEventListener('click', this.handleToggle.bind(this))
        }

        handleToggle(e) {
            if(!e.target.closest('summary')) return //delegate for dynamic content
            e.preventDefault()
            
            if(this.details.hasAttribute('open')){
                this.details.removeAttribute('open')
            } else {
                this.details.setAttribute('open', '')
            }
        }
    })
}